import gql from 'graphql-tag';

export const getInvestigationMetricsBasicQuery = gql`query InvestigationMetricsBasicConnection($filters: [InvestigationMetricsFilter], $orderBy: InvestigationMetricsOrderBy, $first: Int, $last: Int, $before: ID, $after: ID, $sortOrder: SortOrder) {
  investigationMetricsBasicConnection(first: $first, last: $last, before: $before, after: $after, filters: $filters, orderBy: $orderBy, sortOrder: $sortOrder) {
    pageInfo {
      limit
      offset
    }
    totalCount
    edges {
      cursor
      node {
        year
        data
      }
    }
  }
}`;
